import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as _ from "lodash";
import * as fromRootStore from "../../../reducers";
import {
  Combo2Service,
  ComboService,
  ExcelService,
  ReportService,
  SalesPlanService,
} from "../../../services/index";
declare var google;

@Component({
  selector: "non-ordered-design-report",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./NonOrderedDesignReport.html",
})
export class NonOrderedDesignReport implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input("params") params: any;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();

  seasonList = [];
  dataList = [];
  gridOptions: any;
  exceldata: any;
  isLoadMask: Promise<any>;
  selectedDlrMapList: any[];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;
  filter = {
    fin_id: 3,
    season: 0,
    season_id: 3,
    design_no: "",
    opmin: "",
    opmax: "",
    oqmin: "",
    oqmax: "",
    search: "",
    season_from_id: "",
    season_to_id: "",
    season_from: "",
    season_to: "",
  };
  page = {
    limit: 99999,
    count: 0,
    offset: 0,
    orderBy: "agent_name",
    orderDir: "asc",
  };
  finyearList = [];
  agentList = [];

  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild("nameTemplate") nameTemplate: TemplateRef<any>;
  @ViewChild("addrTemplate") addrTemplate: TemplateRef<any>;
  @ViewChild("editDeleteTemplate") editDeleteTemplate: TemplateRef<any>;
  @ViewChild("filterPanel") filterPanel;
  @ViewChild("partyDataTable") partyDataTable;

  finyearCtrl: FormControl = new FormControl();
  seasonCtrl: FormControl = new FormControl();
  seasonCtrlFrom: FormControl = new FormControl();
  seasonCtrlTo: FormControl = new FormControl();
  agentCtrl: FormControl = new FormControl();
  columns = [];
  toggleCol = [];
  menu: any;
  reportName = "design_no";
  reportType = "Design";
  filterExpand = false;
  filterData: any = {
    fin_id: 4,
    orderDir: "Asc",
    orderColumn: "design_no",
    genLedid: "",
    //company_id: 0
  };
  agentList$ = [];
  companyInfo: any = [];
  constructor(
    public store: Store<fromRootStore.State>,
    private excelService: ExcelService,
    private combo: Combo2Service,
    private salesplanservice: SalesPlanService,
    private reportService: ReportService,
    public toasterService: ToasterService,
    public datePipe: DatePipe,
    private comboSer: ComboService
  ) {}

  printConfig: any = {
    title: "Non Ordered Design report",
    columns: [],
    rows: [],
  };

  exportToExcel($event) {
    this.excelService.exportAsExcelFile(this.exceldata, this.title);
  }

  loadParams() {
    if (this.params && this.params.data) {
      if (this.params.type === "color") {
        this.reportName = "design_id";
        this.reportType = "Design Color";
        this.filter.design_no = this.params.data.design_no;
        this.filter.season_id = this.params.data.season_id;
        this.title = this.reportType + " Report";
      } else {
        this.title = this.reportType + " Report";
        return;
      }
    }
  }
  ngOnInit(): void {
    this.LoadFinYearList();
    this.getSeason();
    this.filter.oqmax = this.menu.config_wo_type;
    if (this.menu.config_wo_type == "color") {
      this.reportName = "design_id";
      this.reportType = "Design Color";
    } else {
      this.reportName = "design_no";
      this.reportType = "Design";
    }

    this.loadParams();
    this.getColumns();
    this.toggleCol = Object.assign({}, this.columns);
    this.pageCallback({ offset: 0 });
  }

  hotkeys(event) {
    if (this.active) {
    }
  }

  getColumns() {
    this.columns = [
      {
        name: "SNo",
        prop: "sno",
        type: "sno",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
        sortable: false,
        toggle: true,
        summaryFunc: (cells) => "Sample",
      },
      {
        name: "Design no",
        prop: "dispName",
        minWidth: 150,
        maxWidth: 150,
        width: 150,
      },

      {
        name: "Style",
        prop: "style",
        minWidth: 150,
        maxWidth: 150,
        width: 150,
      },

      {
        name: "Type",
        prop: "type",
        minWidth: 150,
        maxWidth: 150,
        width: 150,
      },

      {
        name: "F Qty",
        cellClass: "txtRight",
        prop: "fqty",
        minWidth: 150,
        maxWidth: 150,
        width: 150,
        summary: "sum",
      },
      {
        name: "H Qty",
        cellClass: "txtRight",
        prop: "hqty",
        minWidth: 150,
        maxWidth: 150,
        width: 150,
        summary: "sum",
      },
      {
        name: "Tot Qty",
        cellClass: "txtRight",
        prop: "totqty",
        minWidth: 150,
        maxWidth: 150,
        width: 150,
        summary: "sum",
      },
    ];
    this.gridOptions = {
      columns: this.columns,
      loading: true,
      data: [],
    };
  }

  onOpenedFilter(): void {
    setTimeout(function () {
      $("#filterpartyName").focus();
    }, 100);
  }

  onChangePageSize(limit) {
    this.page.limit = 10000;
    this.getPartySalesOrder();
  }

  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }

  getRowClass(event) {
    return event.rowtype == "summary" ? "summary-row" : "";
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    this.getPartySalesOrder();
  }

  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    this.getPartySalesOrder();
  }

  getPartySalesOrder(): void {
    console.log(this.filter);
    console.log(this.filterData);
    let params = {
      groupBy: this.reportName,
      fin_id: this.filter.fin_id,
      season_id: this.filter.season_id,
      season_from_id: this.filter.season_from_id,
      season_to_id: this.filter.season_to_id,
      search: this.filter.search,
      opmin: this.filter.opmin,
      oqmin: this.filter.oqmin,
      oqmax: this.filter.oqmax,
      opmax: this.filter.opmax,
      orderColumn: `${this.page.orderBy}`,
      orderDir: `${this.page.orderDir}`,
      design_no: this.filter.design_no,
    };
    let that = this;
    //this.store.dispatch(new commonActions.LoadAllParty(params));
    this.isLoadMask = this.reportService
      .getDesignWiseNOReport(params)
      .then(function (res: any) {
        that.loadingIndicator = false;
        //that.dataList = res.data;
        that.page.count = res.data.length;
        that.gridOptions = {
          columns: that.columns,
          data: res.data,
          loading: false,
        };
        that.refreshData();
        that.exceldata = that.getData(that.columns, res.data);
        //that.page.count = res.total;
        //that.refreshData();
        that.printConfig = {
          title: "Non Ordered Design report",
          columns: that.columns,
          rows: that.gridOptions.data,
        };
        //  that.columns = res.columns;
      });
  }
  selectSeason(season, season_range) {
    let that = this;
    that.seasonList.forEach(function (element) {
      if (season == element.season) {
        if (season_range == "season_from") {
          that.filter.season_from_id = element.season_id;
        }
        if (season_range == "season_to") {
          that.filter.season_to_id = element.season_id;
        }
      }
    });
  }
  getData(columns, data) {
    let cols = columns;
    let value = data;
    let rows = [],
      row,
      ind,
      type,
      val,
      rlen = data.length,
      clen = columns.length;

    for (let i = 0; i < data.length; i++) {
      let sno = i + 1;
      row = Object.assign({}, data[i]);
      let newrow = {
        Sno: sno,
      };
      for (let j = 1; j < clen; j++) {
        let type = cols[j].type,
          index = cols[j].index,
          prop = cols[j].prop,
          name = cols[j].name;

        newrow[name] = row[prop];
      }

      rows.push(newrow);
      sno++;
    }
    return rows;
  }

  clearFilter(): void {
    this.filterData = {
      fin_id: "",
    };
    this.applyFilter();
  }

  applyFilter(): void {
    //this.filterExpand = false;
    this.filterPanel.close();
    this.getPartySalesOrder();
  }

  onRowSelected($event) {}

  displayFn(comboType: string, id: number) {
    let list: any[];
    let that = this;
    if (comboType == "FinYear") {
      list = this.finyearList;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { fin_id: id });
      this.filter.fin_id = fitem["fin_id"];
      return fitem["finyear"];
    }
    return "";
  }
  seasonFromFn(season: number) {
    let list: any = [];
    let that = this;
    list = this.seasonList;
    let id = season && season["season_id"] ? season["season_id"] : 0;
    if (id && list.length > 0) {
      let fitem = _.find(list, { season_id: id });
      this.filter.season_from_id = id;
      return fitem["season_name"];
    }
    return "";
  }

  seasonToFn(season: number) {
    let list: any[];
    let that = this;
    list = this.seasonList;
    let id = season && season["season_id"] ? season["season_id"] : 0;
    if (id && list.length > 0) {
      let fitem = _.find(list, { season_id: id });
      this.filter.season_to_id = id;
      return fitem["season_name"];
    }
    return "";
  }
  loadSeasonList() {
    let that = this;
    this.reportService.getNewSeasonList(this.filter).then(function (res) {
      //  this.LoadAgentList();
      that.seasonList = res;
      let fin = res[0]["season_id"];
      if (that.params) {
        fin = that.params.data.season_id;
      }
      that.filter.season_id = fin;
      that.filterData.season_id = fin;
      that.seasonCtrl.setValue({
        season_id: fin,
      });

      that.applyFilter();
    });
  }

  LoadFinYearList() {
    let that = this;
    this.combo.finyearCombo().then((res: any) => {
      //      that.loadSeasonList();
      window["finyear"] = that.finyearCtrl;
      that.finyearList = res.data;
      let fin = res.data[0]["fin_id"];
      if (that.params && that.params.data) {
        fin = that.params.data.fin_id;
      }
      that.filter.fin_id = fin;
      that.filterData.fin_id = fin;
      that.finyearCtrl.setValue(fin);

      // this.getPartySalesOrder();
    });
  }

  displayFn1(comboType: string, id: number) {
    let list: any = [];
    let that = this;
    if (comboType == "Agent") {
      list = this.agentList;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { genLedid: id });
      return fitem["name"];
    }
    return "";
  }
  getSeason() {
    let params = {
      start: 0,
      limit: 100,
      page: 1,
      date: this.datePipe.transform(new Date(), "yyyy"),
    };
    this.comboSer.getSeason(params).then((res: any) => {
      this.seasonList = res;
      // this.partyCtrl.setValue(this.invoicedata['season']);
    });
  }
  LoadAgentList() {
    let that = this;
    this.salesplanservice.getAgentList({}).then((res: any) => {
      that.agentList = res.data;
    });
  }

  refreshData() {
    let columns = this.columns,
      data = this.dataList,
      row = this.getSummaryRow(data, columns);
    data.push(row);
    this.page.count = data.length;
    // this.dataList = data;
  }

  getSummaryRow(data, columns) {
    let row = {
      rowtype: "summary",
    };
    for (let i = 0; i < columns.length; i++) {
      let col = columns[i];
      switch (col.summary) {
        case "sum":
          let total = 0;
          for (let j = 0; j < data.length; j++) {
            let dat = data[j];
            total += dat[col.prop];
          }
          row[col.prop] = Math.round(total * 100) / 100;
          break;
        default:
          row[col.prop] = "";
          break;
      }
    }
    return row;
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/report/NonOrderedDesignReport/NonOrderedDesignReport.ts